export default __webpack_public_path__ + "static/media/Apresentacao.9d594e5a.jpeg";